// Google Analytics 4 configuration — single source of truth.
// Paste a new Measurement ID here to swap; leave empty string to disable.
export const GA_MEASUREMENT_ID = "G-6965DHDPWB";

let initialized = false;

// Loads gtag.js once, defines window.gtag, and disables auto page_view so we
// can send page_view manually on every SPA route change (correct GA4 pattern).
export function initGA4() {
    if (initialized || typeof window === "undefined") return;
    if (!GA_MEASUREMENT_ID) return;
    initialized = true;

    // Guard against duplicate script if this ever runs twice
    if (
        document.querySelector(
            `script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`,
        )
    ) {
        return;
    }

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

// Fire a GA4 page_view for the given path (called on every route change).
export function trackPageView(path) {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
    });
}
